/**
 * SignInScreen: the pre-auth landing (the logo, the product name Olive,
 * the deployment's company name when set, one Sign in button). After an idle sign-out the address carries
 * ?signed_out=idle and the screen says so in one line above the button.
 */

import type { ReactNode } from 'react';
import { signInCompanyName } from '@/lib/deploymentBrand';

export type SignedOutReason = 'idle' | null;

export function signedOutReasonFromSearch(search: string): SignedOutReason {
  return new URLSearchParams(search).get('signed_out') === 'idle' ? 'idle' : null;
}

export interface SignInScreenProps {
  reason: SignedOutReason;
}

export function SignInScreen({ reason }: SignInScreenProps): ReactNode {
  const company = signInCompanyName();
  return (
    <main className="min-h-screen flex items-center justify-center">
      <div className="text-center px-4">
        <img src="/brand/olive-dove-martini.png" alt="" className="mx-auto mb-4 h-40 w-auto" />
        <h1 className="font-display text-5xl font-semibold tracking-[-0.01em] text-sage-800">Olive</h1>
        {company !== null && (
          <p className="mt-2 font-display text-lg italic tracking-wide text-sage-700" data-testid="sign-in-company">
            {company}
          </p>
        )}
        <div className="mb-8" />
        {reason === 'idle' && (
          <p className="text-sm text-ink-soft mb-6 max-w-xs mx-auto" data-testid="signed-out-reason">
            You were signed out after 30 minutes away. Sign in to carry on.
          </p>
        )}
        <a
          href="/.auth/login/aad"
          className="inline-flex items-center justify-center min-h-11 min-w-11 px-6 py-2 bg-sage-800 text-white rounded-md text-sm font-display font-semibold hover:bg-sage-700 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-500"
        >
          Sign in
        </a>
      </div>
    </main>
  );
}
